import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../../misc';

//material ui
import CircularProgress from '@material-ui/core/CircularProgress';

import Resizer from 'react-image-file-resizer';

import { FaceRecognitionUpload } from '../face-recognition-upload';
import GDPRHint from '../GDPRHint';

import { UploadFacePhotoMutation } from '../../../mutations';

import environment from '../../../environment';

import { setToLocalStorage, getFromLocalStorage, removeFromLocalStorage} from '../../../utils/browser-storage';
import { sendError } from '../../../appsignal';

class ExtendedSearchFaceSearchTab extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      showSpinner: false,
      recognitionPhoto: null,
    }

    this.handleSearchByFace = this.handleSearchByFace.bind(this);
    this.handleRecognitionPhotoChange = this.handleRecognitionPhotoChange.bind(this);
  }

  handleRecognitionPhotoChange(event) {
    const selectedPhoto = event.target.files[0];
    // 'selectedPhoto' can be undefined if no file has been selected in the file manager
    if (selectedPhoto) {
      Resizer.imageFileResizer(selectedPhoto, 800, 800, 'JPEG', 70, 0, uri => {
          this._decodeToFile(uri)
            .then(function(photoFile) {
              this.setState({ recognitionPhoto: photoFile });
            }.bind(this)).catch(error => {
              sendError(error);
            });
        },
      );
    }
  }

  // Encode a file as base64
  _encodeFile(file) {
    return new Promise(function(resolve, reject) {
      const reader = new FileReader();
      reader.onloadend = function() {
        resolve(reader.result);
      };
      reader.readAsDataURL(file);
    });
  }

  //return a promise that resolves with a File instance
  _decodeToFile(b64Data, sliceSize=1024) {

    return new Promise(function(resolve, reject) {
      const byteCharacters = atob(b64Data.split(',')[1]);
      const byteArrays = [];
    
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
    
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
    
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
    
      const blob = new Blob(byteArrays, { type: 'image/*' });
      resolve(blob);
    });
  }

  setFacePhotoFromCache() {
    const encodedPhoto = getFromLocalStorage('base64-photo-ext');
    if (encodedPhoto !== null) {
      this._decodeToFile(encodedPhoto)
        .then(function(photoFile) {
          this.setState({ recognitionPhoto: photoFile });
        }.bind(this)).catch(error => {
          sendError(error);
        });
    } else {
      removeFromLocalStorage('base64-photo-ext');
      return null;
    }
  }

  handleSearchByFace() {
    const { eventId, startnumber, onNavigateTo } = this.props;
    const { recognitionPhoto } = this.state;

    if (recognitionPhoto === null) {
      document.getElementById("faceRecoExtInput").click();
      return
    }

    // Show spinner after search button click
    this.setState({ showSpinner: true });

    // Using face recognition
    if (recognitionPhoto !== null) {
      this._encodeFile(recognitionPhoto)
        .then(function(encodedPhoto) {
          setToLocalStorage('base64-photo-ext', encodedPhoto)
        }).catch(error => {
          sendError(error);
        });
      UploadFacePhotoMutation.commit(
        environment,
        recognitionPhoto,
        eventId,
        (error, _faceStartNumber) => {
          if (error) {
            this.setState({ showSpinner: false });
          } else {
            this.setState({ showSpinner: false }, () => {
	      onNavigateTo(`/event/${eventId}/face/${_faceStartNumber}/${startnumber}`);
	    });
	  }
        }
      );
      return;
    }

    // hide spinner after request is done
    this.setState({ showSpinner: false });
  }

  render() {
    const { startnumber } = this.props;
    const { 
      showSpinner,
      recognitionPhoto,
    } = this.state;

    return (
      <div className="extended-search-facesearch-container">
        <div>
          <h2>
            <FormattedMessageWrappedInSpan
              id="extendedSearchFaceSearchTab.ownSearch.title"
              defaultMessage="Search with a photo of your face"
            />
          </h2>
          <p>
            <FormattedMessageWrappedInSpan
              id="extendedSearchFaceSearchTab.ownSearch.description"
              defaultMessage="Upload a selfie and we will show you more of your photos"
            />
          </p>
          <FaceRecognitionUpload
            imgSrc={
              recognitionPhoto !== null && recognitionPhoto !== undefined ? URL.createObjectURL(recognitionPhoto) : this.setFacePhotoFromCache()
            }
	    elementId="faceRecoExtInput"
            onChange={this.handleRecognitionPhotoChange}
          />
          {showSpinner && <CircularProgress />}
          {!showSpinner && (
            <button className="primary" onClick={this.handleSearchByFace}>
              <FormattedMessageWrappedInSpan
                id="extendedSearchFaceSearchTab.ownSearch.searchButton"
                defaultMessage="Search"
              />
            </button>
          )}
        </div>
      </div>
    );
  }
}

ExtendedSearchFaceSearchTab.propTypes = {
  relay: PropTypes.object,
  eventId: PropTypes.number,
  startnumber: PropTypes.string,
  onNavigateTo: PropTypes.func,
};

export { ExtendedSearchFaceSearchTab };

export default ExtendedSearchFaceSearchTab;
